<template>
  <div class="modal-window bds072 bds057">
    <header class="modal-header">
      <div class="tit">
        <span class="cursor-pointer" @click="boardLink">{{modalInfo.item.paperTitle}}</span>
      </div>
      <button @click="closePopup" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="top">
        <div class="date">
          {{ $i18nUtil.trans("message.requestDate","요청일") }} {{ $moment(editorData.regDate).format("YYYY.MM.DD") }}
        </div>
        <div class="droplayer tooltipmember relative right avatar">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="getMemberTooltip(editorData.regUserId)"
                ><div
                  class="avatar img user-photo"
                  :data-user-id="editorData.regUserId"
                >
                  <img src="@/assets/img/no-avatar.png" alt="" />
                </div>
                {{ editorData.regUserName }}</v-btn
              >
            </template>
            <div class="dropdown-list">
              <div
                class="tooltip-b tl small member"
                :id="'tooltip' + editorData.regUserId"
              >
                <ul class="">
                  <li>
                    <div class="row1">
                      <div
                        class="avatar img user-photo"
                        :data-user-id="editorData.regUserId"
                      >
                        <img src="@/assets/img/no-avatar.png" alt="" />
                      </div>
                      <div class="name">
                        {{ deptInfo.userName }}
                        <span>{{ deptInfo.jobPositionName }}</span>
                      </div>
                      <div class="co">
                        <span>{{ deptInfo.companyName }}</span>
                        <span>{{ deptInfo.deptName }}</span>
                      </div>
                    </div>
                    <div class="mail ell-singleline">
                      {{ deptInfo.email }}
                    </div>
                    <div class="tel">{{ deptInfo.cellPhoneNo }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </v-menu>
        </div>
      </div>

      <div class="scroll">
        <div class="inner">
          <textarea
            name=""
            id="info"
            @input="doCheck(500)"
            onfocus="this.blur()"
            readonly
            v-model="editorData.contents"
          >
          </textarea>

          <div class="attachfile_box" v-if="upfile.files.length > 0">
            <div class="scroll">
              <div
                class="file_row clear"
                v-for="(fileItem, fileIndex) in upfile.files"
                :key="fileIndex"
                :transfer-data="fileItem"
              >
                <div
                  class="file_name"
                  :class="icoFile(fileItem)"
                  @click="
                    callFileViewer({
                      type: 'SINGLE',
                      file: Object(fileItem),
                    })
                  "
                >
                  {{ fileItem.name || fileItem.fileName }}
                </div>
                <!--  
                    - 2021.05.21
                    - BoardOpinionModalU.vue 화면은 의사결정 결정자 화면 
                    - 결정자는 첨부파일 삭제 못함.
                 -->
                <!-- <div class="btn">
                  <div class="droplayer icon more large right nosel">
                    <v-menu bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
                      </template>
                      <div class="dropdown-list">
                        <div class="dropdown-list-item">
                          <div class="tit">
                            <button
                              type="button"
                              @click="confirmDelFile(fileItem, fileIndex)"
                            >
                              파일 삭제
                            </button>
                          </div>
                        </div>
                      </div>
                    </v-menu>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="todo_wrap_write">
        <div class="top clear">
          <div class="label-fin" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : '' ">{{ $i18nUtil.trans("entity.decision","의사결정") }}</div>
          <div class="status-txt" v-if="editorData.status === 'APPL'">
            {{ $i18nUtil.trans("entity.decision.status.proceeding","승인 전") }}
          </div>

          <div class="status-txt" v-else-if="editorData.status === 'APROVAL'">
            {{ $i18nUtil.trans("entity.decision.status.approval","승인") }}
          </div>
          <div class="status-txt" v-else-if="editorData.status === 'RETURN'">
            {{ $i18nUtil.trans("entity.decision.status.reject","반려") }}
          </div>
          <div class="status-txt" v-else>{{ $i18nUtil.trans("entity.decision.status.defer","보류") }}</div>

          <div class="droplayer tooltipmember relative right avatar fr">
            <div
              class="date"
              v-if="editorData.status != 'APPL' && editorData.deciDate != null"
            >
              {{ $i18nUtil.trans("entity.decision.filter.decisionDate","결정일") }}
              {{ replaceAll(editorData.deciDate.substring(0, 10), "-", ".") }}
            </div>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <div
                    class="avatar img user-photo"
                    :data-user-id="editorData.userId"
                  >
                    <img src="@/assets/img/no-avatar.png" alt="" />
                  </div>
                  {{ editorData.userName }}
                </v-btn>
              </template>
              <div class="dropdown-list">
                <UserTooltip :userId="editorData.userId"></UserTooltip>
              </div>
            </v-menu>
          </div>
        </div>
        <div
          class="write_grp"
          v-if="
            editorData.status === 'APPL' && editorData.userId == userInfo.userId
          "
        >
            <!-- @keyup="doCheck(500)" -->
          <textarea
            id="info2"
            maxlength="501"
            @focus="$event.target.placeholder = ''"
            @focusout="
              $event.target.placeholder = $i18nUtil.trans('message.BoardOpinionModalU.008','의사결정 의견을 입력해주세요.')
            "
            :placeholder="$i18nUtil.trans('message.BoardOpinionModalU.008','의사결정 의견을 입력해주세요.')"
            v-model="editorData.pcontents"
            @input="pcontentsChk($event.target.value)"
          ></textarea>
          <button type="button" v-show="emoticonIcon" class="btn-emoticon" @click="toggleEmoticon(null, 'regist', $event)">
            <span class="hide">이모티콘</span>
          </button>
          <div class="character-limit_box txtr" :class="!emoticonIcon ? 'add-mgt' : ''">
            <span class="error" v-if="error"
              >{{ $i18nUtil.trans("message.exceed.characters","입력 가능한 글자수를 초과하였습니다.") }}</span
            >
            <span class="count"
              >(<b>{{ editorData.pcontents.length }}</b
              >/500)</span
            >
          </div>
          <div class="txt reply-emoticon" v-show="selectedEmoticon != null">
            <img :src="selectedEmoticon ? $emoticonFn.getEmoticonSrc(tenantId, selectedEmoticon.origin) : ''">
            <button type="button" class="btn-ico-del_ty1" @click="selectedEmoticon = null">삭제</button>
          </div>
        </div>

        <div
          class="write_grp"
          v-show="
            editorData.status != 'APPL' || editorData.userId != userInfo.userId
          "
        >
          <textarea
            v-show="editorData.emoticonId == null || editorData.pcontents != ''"
            :placeholder="$i18nUtil.trans('message.BoardOpinionModal.023','등록된 의견이 없습니다.')"
            readonly
            onfocus="this.blur()"
            v-model="editorData.pcontents"
          >
          </textarea>
          <div class="txt reply-emoticon" v-show="editorData.emoticonId != null">
            <img v-if="editorData.emoticonId != null" :src="$emoticonFn.getEmoticonSrc(tenantId, editorData.emoticonId)">
          </div>
        </div>
      </div>
    </div>

    <!-- [이모티콘 선택기 영역] -->
    <EmoticonSelector 
      id="board-emoticon-selector"
      ref="emoticonSelector"
      :emoticonList="emoticonList"
     />
    <!-- /[이모티콘 선택기 영역] -->

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="boardLink"> 
        {{ $i18nUtil.trans("button.board.move","{board} 이동", {board: $i18nUtil.trans("entity.paper","보드") }) }}
      </button>
      <button
        type="button"
        class="btn_ty2"
        @click="status('RETURN', editorData)"
        v-if="
          editorData.userId == userInfo.userId && editorData.status == 'APPL'
        "
      >
        {{ $i18nUtil.trans("entity.decision.status.reject","반려") }}
      </button>
      <button
        type="button"
        class="btn_ty1"
        @click="status('APROVAL', editorData)"
        v-if="
          editorData.userId == userInfo.userId && editorData.status == 'APPL'
        "
      >
        {{ $i18nUtil.trans("entity.decision.status.approval","승인") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import EventBus from "@/js/eventbus/eventBus";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import EmoticonSelector from '@/components/cowork/common/emoticon/EmoticonSelector';

export default {
  components: {
    UserTooltip,
    EmoticonSelector
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: false,
      max: 0,
      count: 0,

      editorData: {},
      upfile: {
        groupId: "",
        paperId: "",
        files: [],
      },
      data: {
        obj: this,
        url: null,
        header: null,
        sendType: null,
        frm: null,
      },
      item: {},
      items: [],
      files: [],
      members: [],
      userInfo: {
        userId: null,
      },
      uploadDecisionFile: [],
      udfform: {
        paperFileId: null,
        seq: null,
        fileId: null,
        fileName: null,
      },
      paperBlock: {},

      deptInfo: {
        userName: "",
        jobPositionName: "",
        companyName: "",
        deptName: "",
        email: "",
        cellPhoneNo: "",
      },
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      
      tenantId: localStorage.getItem("tenantId"),
      emoticonUse: null,
      emoticonIcon: false,
      emoticonItem: 'decisionEmoticon',
      emoticonList: {},
      selectedEmoticon: null,
    };
  },
  updated() {
    this.updateUserPhoto();
  },
  mounted() {
    let obj = this; 
    this.item = this.modalInfo.item;
    this.getUserInfo();
  },
  created() {
    let body = document.querySelector("body");
    body.style.overflow = "hidden";
    // let obj = this;
    // console.log(" Start Created ");
    // this.item = this.modalInfo.item;
    // this.getUserInfo();
    
    this.emoticonUse = this.$emoticonFn.getEmoticonLocation(null);

    EventBus.$on("decisionEmoticon", payload => {
      this.selectedEmoticon = payload.item; // 등록할 이모티콘 정보
    });
  },
  watch: {
    emoticonUse() {
      if(this.emoticonUse != null) {
        this.checkEmoticonUse();
      }
    },
    "emoticonUse.decisionEmoticon": {
      handler() {
        this.emoticonIcon = this.emoticonUse[this.emoticonItem];
      }
    },
  },
  methods: { 
    ...mapActions("decision", ["setDecisionReadYn"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO"]),
    doCheck(max) {
      this.count = document.getElementById("info2").value.length;
      if (this.count > max) {
        this.error = true;
      } else {
        this.error = false;
      }
    },
    getUserInfo() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/userInfo",
        method: "post",
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.userInfo = response.result;
        this.getModalsDecision();
      });
    },
    getModalsDecision() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/getModalsDecision",
        method: "post",
        params: { paperId: this.item.paperId, deciId: this.item.deciId },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        if (response.errorCode != null) {
          obj.closePopup();
        } else {
          obj.editorData = response.result;

          if(obj.$i18nUtil.getLanguage() === 'ko') {
            // locale에 따른 사용자명 영문 처리
          }else{
            obj.editorData.regUserName = obj.editorData.regUserNameEn != null ? obj.editorData.regUserNameEn : obj.editorData.regUserName;
            obj.editorData.userName = obj.editorData.userNameEn != null ? obj.editorData.userNameEn : obj.editorData.userName;
          }
          
          this.initPaperUserList();
          this.getGroupIdAndProjectIdToPaperId();
          if (obj.editorData.confirm == 0) {
            this.confirm();
          }
        }
      });
    },
    getGroupIdAndProjectIdToPaperId() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/getGroupIdAndProjectIdToPaperId",
        method: "post",
        params: { paperId: this.item.paperId },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        this.upfile.groupId = response.result.groupId;
      });
    },
    confirm() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/confirm",
        method: "post",
        params: {
          deciId: this.editorData.deciId,
          userId: this.editorData.userId,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((response) => {
          if(response.errorCode == null){
            obj.setDecisionReadYn();
            obj.refreshBoard();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    refreshBoard(){
      const self = this;
      self.COWORK_REST_SIMPLE_ACTION({
        params: { by:"deci", paperId: this.editorData.paperId, deciId: this.editorData.deciId, update:true },
        url: "/api/copaper/paper/block/refreshBlockBy",
        method: "post",
      }).then((response) => { });
    },
    status(_status, param) {
      if (_status == "RETURN") {
        if (
          (this.editorData.pcontents == null ||
          this.editorData.pcontents == "") &&
          (this.selectedEmoticon === null)
        ) {
          this.showAlertDialog(this.$i18nUtil.trans("AB050"));
          // this.error = true;
          return;
        }
      }
      if (!this.error) {
        param.pcontents = this.editorData.pcontents;
        param.status = _status;
        param.emoticonId = this.selectedEmoticon == null ? null : this.selectedEmoticon.emoticonId;

        let _obj = this;
        let obj = this;
        let reqData = {
          url: "/api/copaper/decision/process",
          method: "post",
          params: param,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          _obj.items = response.result;
          if (this.item.paperBlockId) {
            EventBus.$emit(
              "DecisionBlockWidgetRefresh",
              this.item.paperBlockId
            );
          }

          EventBus.$emit("refreshPerDeciNewPage");
          this.toastInfo.message = this.$i18nUtil.trans("message.BoardOpinionModalU.002","의사결정이 완료되었습니다");
          this.showToast(this.toastInfo);
          _obj.$emit("closeBoardLeftModal", _obj.items);
          _obj.closePopup();
        });
      }
    },
    initPaperUserList() {
      let newMember = [];
      let obj = this;
      let reqData = {
        url: "/api/copaper/paperuser/getPaperUserList",
        method: "post",
        params: {
          paperId: this.editorData.paperId,
        },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let result = response.result;
        for (let i = 0; i < result.userList.length; i++) {
          var member = { userId: "", userName: "" };
          member.userId = result.userList[i].userId;
          member.userName = result.userList[i].userName;
          newMember.push(member);
        }
        obj.members = newMember;

        let targetIndex = -1;
        obj.members.forEach((elem, index) => {
          let memberUserId = elem.userId || elem.paperUserId;
          if (memberUserId === obj.userInfo.userId) {
            targetIndex = index;
          }
        });
        if (targetIndex !== -1) {
          obj.members.splice(targetIndex, 1);
        }
        obj.initDecisionThisFile();
      });
    },
    initDecisionThisFile() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/decisionThisFile",
        method: "post",
        params: this.item,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.upfile.files = response.result;
        obj.initPaperGroupId();
      });
    },
    initPaperGroupId() {
      let obj = this;
      // let param = this.editorData;
      // let url = "/api/copaper/opinion/getPaperGroupId";
      // this.$axios.post(url, param).then(response => {
      // obj.upfile.groupId = response.data.result;
      obj.upfile.paperId = obj.editorData.paperId;
      // 접속자 권한 확인
      // 작성자
      if (obj.editorData.regUserId == obj.userInfo.userId) {
        // 진행상태구분(APPL:신청,APROVAL:승인완료,RETURN:반려,DEFER:보류)
        if (
          obj.editorData.status == null ||
          obj.editorData.status == "" ||
          obj.editorData.status == "APPL"
        ) {
          obj.editorData.isEditFlag = true;
        }
      }
      // 결정자
      if (obj.editorData.userId == obj.userInfo.userId) {
        // 진행상태구분(APPL:신청,APROVAL:승인완료,RETURN:반려,DEFER:보류)
        if (
          obj.editorData.status == null ||
          obj.editorData.status == "" ||
          obj.editorData.status == "APPL"
        ) {
          obj.editorData.isProcessEditFlag = true;
        }
      }
      // });
    },
    getDecisionThisFile() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/decisionThisFile",
        method: "post",
        params: this.item,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.upfile.files = response.result;
      });
    },
    setuserId(param1, param2) {
      if (
        $("#btn_opinionu_modal_user") != null &&
        $("#btn_opinionu_modal_user").length > 0
      ) {
        $("#btn_opinionu_modal_user")[0].classList.toggle("active");
      }
      this.editorData.userId = param1;
      this.editorData.userName = param2;
    },
    changeFile() {
      if (
        this.$refs.uploadfile.files == null ||
        this.$refs.uploadfile.files.length == 0
      ) {
        return;
      }
      let files = this.$refs.uploadfile.files;
      if (files.length) {
        for (let i = 0; i < files.length; i++) {
          this.upfile.files.push(files[i]);
          this.files.push({
            fileId: null,
            fileName: files[i].name,
            _fileStatus: "NOT_SAVE",
            _fileElemIndex: i,
          });
        }
      }
      // this.upfile.files = [];
    },
    confirmDelFile(_fileItem, _fileIndex) {
      let obj = this;
      obj.showConfirmDialog(
        { width: "400px" },
        obj.$i18nUtil.trans("title.dialog.notice","알림"),
        obj.$i18nUtil.trans("AB013"),
        obj.$i18nUtil.trans("button.dialog.delete","삭제"),
        obj.delFile,
        { fileItem: _fileItem, fileIndex: _fileIndex },
        obj.$i18nUtil.trans("button.dialog.cancel","취소"),
        null,
        "delFile"
      );
    },
    delFile(_data) {
      let _fileItem = _data.modalParam.fileItem;
      let _fileIndex = _data.modalParam.fileIndex;

      if (
        $("#btn_etc_opinionu" + _fileIndex) != null &&
        $("#btn_etc_opinionu" + _fileIndex).length > 0
      ) {
        $("#btn_etc_opinionu" + _fileIndex)[0].classList.toggle("active");
      }
      if (_fileItem.fileId == null) {
        if (
          _fileItem._fileStatus != null &&
          _fileItem._fileStatus == "NOT_SAVE"
        ) {
          this.upfile.files.splice(_fileItem._fileElemIndex, 1);
          this.files.splice(_fileIndex, 1);
          return;
        } else {
          return;
        }
      }
      let obj = this;
      let checkData = {
        url: "/api/copaper/decision/checkUploadStatus",
        method: "post",
        params: _fileItem,
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(checkData)
        .then(function (res) {
          let uploadStatus = res.result.uploadStatus;
          if (uploadStatus == "COMPLETE") {
            let reqData = {
              url: "/api/cofile/paper/deleteAttach",
              method: "post",
              params: {
                groupId: obj.upfile.groupId,
                fileId: String(_fileItem.fileId),
              },
            };
            obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
              if (
                response.errorCode != null &&
                response.errorCode != undefined &&
                response.errorCode.length > 0
              ) {
                obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardOpinionModal.012","파일 삭제가 실패했습니다."), null, {
                  width: "440px",
                });
                return;
              }
              obj.deleteDecisionPaperFile(String(_fileItem.fileId));
            });
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinionModal.016","파일 업로드 처리중입니다.");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
          obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinionModal.016","파일 업로드 처리중입니다.");
          obj.showToast(obj.toastInfo);
        });
    },
    deleteDecisionPaperFile(param) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/deleteDecisionPaperFile",
        method: "post",
        params: {
          paperId: obj.editorData.paperId,
          paperFileId: obj.editorData.paperFileId,
          fileId: param,
          regUserId: obj.editorData.regUserId,
        },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.getDecisionThisFile();
        obj.toastInfo.message = obj.$i18nUtil.trans("TB011"); // 파일이 삭제되었습니다.
        obj.showToast(obj.toastInfo);
      });
    },
    downloadOpinionFile(_fileItem, _fileIndex) {
      if (
        $("#btn_etc_opinionu" + _fileIndex) != null &&
        $("#btn_etc_opinionu" + _fileIndex).length > 0
      ) {
        $("#btn_etc_opinionu" + _fileIndex)[0].classList.toggle("active");
      }
      if (_fileItem.fileId == null) {
        this.showAlertDialog(this.$i18nUtil.trans("message.BoardOpinionModal.014","등록이 안된 파일입니다."), null, {
          width: "440px",
        });
        return;
      }
      let header = { responseType: "blob", "Content-Type": "application/json" };
      let fileName = _fileItem.fileName;
      let param = {
        fileId: _fileItem.fileId,
        type: "SINGLE",
        groupId: this.upfile.groupId,
      };
      let url = "/api/cofile/cofile/download";
      this.$axios
        .post(url, param, header)
        .then((res) => {
          let blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          const url = window.URL.createObjectURL(blob);
          /* IE에서 발생하는 오류 억제 */
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const link = document.createElement("a");
            const contentDisposition =
              res.headers["content-disposition"]; /* 파일 이름 */
            link.target = "_self";
            link.href = url;
            link.setAttribute("download", fileName);
            link.style.cssText = "display:none";
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        })
        .catch(function (err) {
          console.log("파일 업로드 실패");
          console.log(err);
        });
    },
    /* synap 파일 뷰어 호출 */
    callFileViewer(param) {
      let obj = this;
      if (param.file.fileId == null) {
        alert(obj.$i18nUtil.trans("message.BoardOpinionModal.015","저장 후에 파일을 볼 수 있습니다."));
        return;
      }

      let reqData = {
        url: "/api/copaper/decision/checkUploadStatus",
        method: "post",
        params: param.file,
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          let uploadStatus = res.result.uploadStatus;
          if (uploadStatus == "COMPLETE") {
            // this.$router.push(
            // 	"/general/viewer/" + this.upfile.groupId + "/" + param.fileId
            // );
            let hanwha = $(location).attr("origin");
            let groupId = obj.upfile.groupId;
            if (groupId != null || groupId != "") {
              window.open(
                hanwha + "/general/viewer/" + groupId + "/" + param.file.fileId
              );
            }
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinionModal.016","파일 업로드 처리중입니다.");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
          obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinionModal.016","파일 업로드 처리중입니다.");
          obj.showToast(obj.toastInfo);
        });
    },
    pcontentsChk(value) {
      let obj = this;
      if (value.length > 500) {
        this.error = true;
      } else {
        this.error = false;
        this.editorData.pcontents = value;
      }
    },
    icoFile(fileItem) {
      if (fileItem.type != null) {
        if (fileItem.type == "application/pdf") {
          return "ico-file-pdf";
        } else if (fileItem.type == "image/jpeg") {
          return "ico-file-jpg";
        } else if (fileItem.type.indexOf("presentation") != -1) {
          return "ico-file-ppt";
        } else if (fileItem.type.indexOf("sheet") != -1) {
          return "ico-file-xlsx";
        } else if (fileItem.type.indexOf("text") != -1) {
          return "ico-file-txt";
        }
      } else {
        let fileName = fileItem.fileName;
        let str = fileName.substring(fileName.length - 4, fileName.length);
        if (str.indexOf("pdf") != -1) {
          return "ico-file-pdf";
        } else if (str.indexOf("jpg") != -1) {
          return "ico-file-jpg";
        } else if (str.indexOf("ppt") != -1) {
          return "ico-file-ppt";
        } else if (str.indexOf("xlsx") != -1) {
          return "ico-file-xlsx";
        } else if (str.indexOf("txt") != -1) {
          return "ico-file-txt";
        }
      }
    },
    updateUserPhoto() {
      let list = this.$el.querySelectorAll("div.user-photo[data-user-id]");
      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let elem = list[inx];
          let userId = elem.getAttribute("data-user-id");
          let img = elem.querySelector("img");
          this.HW_GET_USER_PHOTO({ img, userId });
        }
      }
    },
    getMemberTooltip(param) {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/todo/getMemberTooltip";
      reqData.method = "post";
      reqData.params = {
        userId: param,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        if (response.errorCode) {
          alert(response.errorCode);
        }
        this.deptInfo = response.result;
      });
    },
    boardLink() {
      window.open("/general/boardTarget/" + this.editorData.paperId + "/" + this.editorData.paperBlockId , "_blank");
    },
    replaceAll(str, input, output) {
      return str.split(input).join(output);
    },
    closePopup() {
      let body = document.querySelector("body");
      body.style.removeProperty("overflow");
      if (this.modalInfo.onclose) {
        this.modalInfo.onclose();
      }
      this.$emit("close");
    },
    toggleEmoticon(comment, type, event) {
      /* 이모티콘 아이콘 활성화 */
      event.target.className === 'btn-emoticon' ? event.target.classList.add('active') : '';
      this.$refs.emoticonSelector.toggleEmoticonSelect(type, this.emoticonItem, comment, event);
    },
    /* 이모티콘 사용 여부 체크 */
    checkEmoticonUse() {
      let item = this.emoticonUse
      for(let key in item) {
        let location = this.$emoticonFn.getEmoticonLocation(key);
        this.$emoticonFn.checkEmoticonUse(location)
          .then(res => {
            this.emoticonUse[key] = res || false;
            if(res) this.getEmoticonLocation(key, location);
          });
      }
    },
    /* 이모티콘 목록 가져오기 */
    getEmoticonLocation(key, location) {
      !this.emoticonUse[key] ? [] :
        this.$emoticonFn.getEmoticonList(this.tenantId, location)
          .then(resp => {
            this.emoticonList[key] = resp
          }) 
    }
  },
};
</script>

<style scoped>
  [class*="todo_wrap"] .enCss {
    width: 100px;
  }
  .modal-footer { margin-top: 30px; }
  .add-mgt {
    margin-top: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/opinion/BoardOpinionModalU.vue